import axios from "../axios";

export const lessonReport = async (teacherId, value) => {
   const {data} = await axios.post(`/teachers/${teacherId}/lessons`, value)
  
   return data
}